import dayjs from "dayjs";
import { useNetworkStore } from "@/composables/network/useNetwork";

const networkStore = () => {
  try {
    return useNetworkStore();
  } catch {
    return {};
  }
};

const storagePersisted = async () => {
  try {
    return (await globalThis.navigator.storage?.persisted?.()) ?? null;
  } catch {
    return null;
  }
};

const networkState = (online, offlineMode) => {
  if (offlineMode) return "offline_mode";
  return online ? "online" : "offline";
};

export const addNetworkContext = async (event) => {
  if (!event) return event;
  const online = globalThis.navigator.onLine;
  const { isOfflineMode = false, lastServerReachAt = null } = networkStore();
  event.tags = {
    ...event.tags,
    network_state: networkState(online, isOfflineMode),
  };
  event.contexts = {
    ...event.contexts,
    network: {
      online,
      offlineMode: isOfflineMode,
      lastServerReachAt: lastServerReachAt
        ? dayjs(lastServerReachAt).toISOString()
        : null,
      minutesSinceServerReach: lastServerReachAt
        ? dayjs().diff(lastServerReachAt, "minute")
        : null,
      storagePersisted: await storagePersisted(),
    },
  };
  return event;
};
